import { T } from '@tribeplatform/react-components/i18n'

import { BlockBadge } from './BlockBadge.js'

interface Props {
  deprecationMessage: string
}

export const DeprecatedBlockBadge = ({ deprecationMessage }: Props) => {
  return (
    <BlockBadge
      message={deprecationMessage}
      variant="neutral"
      text={<T id="Generics.Deprecated" defaultMessage="Deprecated" />}
    />
  )
}
